// Copyright (c) 2020 Deere & Company

import './index.scss';

import Notification from './components/notification';
import { addNotificationData } from './action-creator/create-notification';
import { connect } from 'react-redux';
import { deleteNotification } from './action-creator/delete-notification';
import { editNotificationData } from './action-creator/edit-notification';
import { readNotificationData } from './action-creator/read-notification';
import { showLoadingIndicator } from '../../sharedmodules/state/busy-counter';
import { updateModalVisibility } from '../../sharedmodules/action-creators/modal';
import { updateNotificationSequenceData } from './action-creator/edit-notification-sequence';
import { withAuth } from '@okta/okta-react';

const mapStateToProps = (state) => ({
    notifications: state.application.notifications,
    modal: state.application.modal,
    busyCounter: showLoadingIndicator(state.application.busyCounter),
});

const mapDispatchToProps = (dispatch) => ({
    getAdminData: (auth) => dispatch(readNotificationData(auth)),
    addNotificationData: (auth, notification, isVisible) => dispatch(
        addNotificationData(auth, notification, isVisible),
    ),
    editNotificationData: (auth, notification, isVisible) => dispatch(
        editNotificationData(auth, notification, isVisible),
    ),
    updateModalVisibility: (isVisible) => dispatch(updateModalVisibility(isVisible)),
    deleteNotificationItem: (auth, id) => dispatch(deleteNotification(auth, id)),
    updateNotificationSequenceData: (auth, notificationSequence) => dispatch(
        updateNotificationSequenceData(auth, notificationSequence),
    ),
});

export default connect(
    mapStateToProps, mapDispatchToProps,
)(withAuth(Notification));
